import { MERCHANTS_METRIKA_COUNTER_ID } from '../const';
import { getRequestContext, getSafeUserRequestContext } from '../context';
import { getWindow } from '../getWindow';
import { checkIsYCP } from '../ycp';
import { prepareErrorForLog } from './prepareErrorForLog';

export const trackGoal = (goal: string, params?: object) => {
    const { yaCounter } = getRequestContext();

    const ym = getWindow()?.ym;

    if (typeof ym === 'function' && !checkIsYCP()) {
        ym(yaCounter, 'reachGoal', goal, params);
    }
};

export const trackMerchantsReachGoal = (goal: string) => {
    const ym = getWindow()?.ym;

    if (typeof ym === 'function' && checkIsYCP()) {
        ym(MERCHANTS_METRIKA_COUNTER_ID, 'reachGoal', goal);
    }
};

export const trackMerchantsGoal = (actionType: string, params?: object) => {
    const { storeSlug } = getSafeUserRequestContext();

    const ym = getWindow()?.ym;

    if (typeof ym === 'function' && checkIsYCP()) {
        ym(MERCHANTS_METRIKA_COUNTER_ID, 'params', { ...(storeSlug && { storeSlug }), ...params, actionType });
    }
};

type ParamsWithoutStatus = Record<string, unknown> & {
    status?: never;
};

export const trackMerchantsGoalSuccess = (actionType: string, params?: ParamsWithoutStatus) => {
    trackMerchantsGoal(actionType, { status: 'success', ...params });
};

export const trackMerchantsGoalError = (actionType: string, params?: ParamsWithoutStatus) => {
    const error = params && 'error' in params ? params.error : undefined;
    const errors = params && 'errors' in params && Array.isArray(params.errors) ? params.errors : undefined;

    trackMerchantsGoal(actionType, {
        status: 'error',
        ...params,
        ...(error === undefined ? null : { error: prepareErrorForLog(error) }),
        ...(errors === undefined ? null : { errors: errors.map(prepareErrorForLog) }),
    });
};
